import React, { useState } from "react";
import { Card, Col, Space, Table, Tag, Typography } from "antd";
import { dateToTime } from "../../../../utils/date";
const QuestionResponsesText = ({ question }) => {
    const [pageNumber, setPageNumber] = useState(1);

    const onChangePage = (page) => {
        setPageNumber(page);
    };

    const createDataSource = () => {
        return question?.responses?.map((res, index) => ({
            ...res,
            date: dateToTime(res.date),
            key: index,
        }));
    };
    const createColumns = () => {
        const arr = [];
        for (const key in question?.responses?.[0]) {
            arr.push({
                title: key.charAt(0).toUpperCase() + key.slice(1),
                dataIndex: key,
                key: key,
            });
        }
        return arr;
    };

    return (
        <Col span={24}>
            <Card
                bordered={true}
                style={{
                    background: "#fafafa",
                    textAlign: "left",
                }}
            >
                <Typography.Title level={4}>
                    {question.headline}
                </Typography.Title>
                <div
                    style={{
                        marginTop: "20px",
                    }}
                >
                    <Tag color="blue">Free text</Tag>
                    <Tag color="orange">
                        {question.responses.length}{" "}
                        {question.responses.length === 1
                            ? "response"
                            : "responses"}
                    </Tag>
                </div>
                <Space
                    direction="vertical"
                    size="large"
                    style={{ marginTop: "50px", width: "100%" }}
                >
                    <Table
                        dataSource={createDataSource()}
                        columns={createColumns()}
                        pagination={{
                            pageSize: 5,
                            current: pageNumber,
                            onChange: onChangePage,
                            total: question?.responses?.length,
                        }}
                    />
                </Space>
            </Card>
        </Col>
    );
};

export default QuestionResponsesText;
